import React, {useContext, useEffect, useState} from 'react';
import {TableColumn, TableSettings} from "../../../tableSettings";
import AbstractListView, {
  DataFetchResult,ExportRowRenderer,ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../common/AbstractListView";
import constants from '../../../constants';
import {amsVoyageList,} from '../tableSettings';
import {Search} from "../../../filtering";
import {
  DateRenderer,DateTimeRenderer,NullableCheckboxIconRenderer,TextAlignLeftRenderer,TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import JobListViewContext, { RightClickContext } from '../../common/JobListViewContext';
import { ActionButtonItem, borderColors, splitMenuItemsIntoSections } from '../../../ui/ActionButton';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import {JobNames} from '../../../framework.core/JobNames';
import {AmsVoyageListItem} from '../../../fms.data/models/AmsVoyageListItem';
import * as XCol from '../../../framework.core/XExportColumn';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import IfmsModal from '../../../ui/IfmsModal';
import ViewVoyage from './implementation/ViewVoyage';
import CheckBoxUncontrolled from "../../../ui/CheckBoxUncontrolled";
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import ApplicationContext from '../../../ApplicationContext';
import { ListFilterType } from '../../../fms.core/constants';
import { useHistory } from 'react-router';
import { openNewPage, NavigationType } from '../../../util/navigationHelpers';
import { nullableCheckBoxValue } from '../../common/commonExportFormat';
import IconButton, { ViewIconButton } from '../../../ui/IconButton';
import CBlockIcon2 from '../../../img/Cancel Block2.svg';
import CBlockIcon2_D from '../../../img/Cancel Block_Dark2.svg';
import DownIcon2 from '../../../img/AMS - Download to OI2.svg';
import DownIcon2_D from '../../../img/AMS - Download to OI_Dark2.svg';
import BlockIcon2 from '../../../img/Block2.svg';
import BlockIcon2_D from '../../../img/Block_Dark.svg';
import voyageAll2 from '../../../img/AMS - List All2.svg';
import voyageAll2_D from '../../../img/AMS - List All_Dark2.svg';
import voyageNotDown2 from '../../../img/AMS - download-not2.svg';
import voyageNotDown2_D from '../../../img/AMS - download-not_Dark2.svg';
import voyageDown2 from '../../../img/AMS - downloaded2.svg';
import voyageDown2_D from '../../../img/AMS - downloaded_Dark2.svg';

// function BlockRenderer({value, row}: any) {
//   /*const appContext = useContext(ApplicationContext);
//   const jobListContext = useContext(JobListViewContext);

//   async function updateConfirmed(newValue:boolean) {
//     const updatedRow = await appContext.api.setCrdbConfirmed(row.original.id, newValue);
//     jobListContext.updateDataRow(updatedRow);
//   }

//   return (
//     <div style={{width: '100%', textAlign: 'center'}}>
//       <CheckBoxUncontrolled initialValue={value as boolean} onChange={updateConfirmed} />
//     </div>
//   );*/
//   return (
//     <div style={{width: '100%', textAlign: 'center'}}>
//       <CheckBoxUncontrolled initialValue={value as boolean} />
//     </div>
//   );
// }

function useAMSVOperations() {
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);

  function switchToHblFor(voyage:AmsVoyageListItem|null) {
    if (!voyage) {
      return;
    }
    jobListContext.setFilterForScreenExternally('/common/joblistview/AMSH/oceanImport', 
      'amsVoyageId', '', voyage.id, '', false, true);
    openNewPage(history, `/common/joblistview/AMSH/oceanImport`, NavigationType.newPage);
  }
  return { switchToHblFor};
}

function useSelectedAMSVOperations() {
  const jobListContext = useContext(JobListViewContext);
  const { switchToHblFor} = useAMSVOperations();

  const selectedElement = jobListContext.selectedElement as AmsVoyageListItem|null;

  function view() {
    jobListContext.showPopupRow();
  }

  function switchToAmsHbl() {
    const selectedElement = jobListContext.selectedElement as AmsVoyageListItem;
    switchToHblFor(selectedElement);
  }

  return { selectedElement, view, switchToAmsHbl };
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { view, switchToAmsHbl } = useSelectedAMSVOperations();
  const jobListContext = useContext(JobListViewContext);
  // const selectedElement = jobListContext.selectedElement as OceanQuoteListItem;
  // const appContext = useContext(ApplicationContext);
  // const [showGlobalOkDialog] = useGlobalOkDialog();

  const items = [
    { label: 'View', shortcut: 'F9', separator: true },
    { label: 'Go to AMS HBL List', shortcut: 'F4', separator: false },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        view();
        break;
      case 1:
        switchToAmsHbl();
        break;
      case 2:
        jobListContext.triggerTableSearch('F5');
        break;
      case 3:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      case 4:
        jobListContext.reloadData();
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function ViListCommands() {
  const { selectedElement } = useSelectedAMSVOperations();
  const [ showGlobalYesNoDialog ] = useGlobalYesNoDialog();
  const [view, showView] = useState(false);
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const listFilter = jobListContext.listFilter || 'A';
  const history = useHistory();

  async function block(isBlock: boolean) {
    const doBlock = await showGlobalYesNoDialog(<p style={{ fontWeight: 'bold', fontSize: '13px' }}>Are you sure you want to {(isBlock ? "Block" : "Cancel block")}?</p>,false, 0, true)

    if (doBlock) {
      const id = selectedElement?.id;

      await appContext.api.block(JobNames.AMSVoyage, id, isBlock);

      jobListContext.reloadData();
    } else {
      return;
    }
  }
  function dismissView() {
    showView(false);
    jobListContext.dismissPopupRow();
  }

  async function changeVoyageListData(type: string) {
    jobListContext.setListFilter?.(type);
    const listFilterType = type === 'A' ? ListFilterType.All : (type === 'D' ? ListFilterType.Downloaded : ListFilterType.Virgin);

    jobListContext.changeListData?.(
      JobNames.AMSVoyage,
      'AmsVoyageListItem',
      AmsVoyageListItem.calculateSearchParameters(jobListContext.search, AmsVoyageListItem.MapSearchFields),
      'AMS',
      listFilterType,
      AmsVoyageListItem.formatData 
    );
  }

  async function viewDownloadView() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;

    const viewUrl = `/oceanImport/download/${JobNames.AMSVoyage}/${id}`;

    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  return (
    <div className="ifms-common-no-vertical-separator">
      {appContext.suntekSettings?.company?.billingsTabVersion === 2 ? <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"} /> : <></>}
      <ViewIconButton
        disabled={!selectedElement}
        name='voyage-list-view-button'
        onClick={() => showView(true)}
        iconHeight='26px'
      />
        <IconButton
          disabled={!selectedElement}
          onClick={() => block(true)}
          data-tooltip='Block' icon={appContext.useDarkMode ? BlockIcon2_D : BlockIcon2}
          style={{marginLeft:'3px', marginRight:'3px'}}
        >
      </IconButton>
      <IconButton
        disabled={!selectedElement}
        onClick={() => block(false)}
        data-tooltip='Cancel Block' icon={appContext.useDarkMode ? CBlockIcon2_D : CBlockIcon2}
        style={{marginLeft:'3px', marginRight:'3px'}}
      >
      </IconButton>

      {appContext.suntekSettings?.company?.billingsTabVersion === 2 ? <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"} /> : <></>}
      <IconButton
        disabled={!selectedElement}
        onClick={() => viewDownloadView()}
        data-tooltip='Download' icon={appContext.useDarkMode ? DownIcon2_D : DownIcon2}
        style={{marginLeft:'3px', marginRight:'3px'}}
      > 
      </IconButton>
      {appContext.suntekSettings?.company?.billingsTabVersion === 2 ? <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"} /> : <></>}
      <IconButton
        size='imgStyle'
        data-tooltip="All"
        disabled={listFilter === 'A'}
        onClick={async () => {
          changeVoyageListData('A')
        }}
        icon={appContext.useDarkMode ? voyageAll2_D : voyageAll2}
        style={{marginLeft:'3px', marginRight:'3px'}}>
      </IconButton>
      <IconButton
        size='imgStyle'
        data-tooltip="Downloaded"
        disabled={listFilter === 'D'}
        onClick={async () => {
          changeVoyageListData('D')
        }}
        icon={appContext.useDarkMode ? voyageDown2_D : voyageDown2}
        style={{marginLeft:'3px', marginRight:'3px'}}>
      </IconButton>
      <IconButton
        size='imgStyle'
        data-tooltip="Ready to Download"
        disabled={listFilter === 'N'}
        onClick={async () => {
          changeVoyageListData('N')
        }}
        icon={appContext.useDarkMode ? voyageNotDown2_D : voyageNotDown2}
        style={{marginLeft:'3px', marginRight:'3px'}}>
      </IconButton>
      {appContext.suntekSettings?.company?.billingsTabVersion === 2 ? <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"} /> : <></>}
      <IfmsModal isBlueHeader onCancel={dismissView} draggable isOpen={view || !!jobListContext.viewPopupRow} title="View Voyage" width="760px">
        <ViewVoyage onPopupClose={dismissView} selectedElementId={selectedElement?.id ?? ''} />
      </IfmsModal>
    </div>
  );
}

function ViListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function formatData(data:Array<AmsVoyageListItem>) {
  return data;
}

function ViListViewExtras() {
  useFunctionKeys({onFunction: onFunctionKey});
  const { view, switchToAmsHbl } = useSelectedAMSVOperations();

  const jobListContext = useContext(JobListViewContext);

  const [unprocessedFkey, setUnprocessedFkey] = useState<string|null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F4") {
      switchToAmsHbl();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey:string) {
    if (['F4', 'F8', 'F9', 'F11'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  return null;
}

/**
 * Concrete implementation for AMS Voyage List screen
 *
 * @class VoyageListView
 * @extends {AbstractListView}
 */
 class VoyageListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(JobNames.AMSVoyage, 'AmsVoyageListItem',
    AmsVoyageListItem.calculateSearchParameters(search,AmsVoyageListItem.MapSearchFields),
    pageNum,
    limit,
    search.pageSize,
    search.pagePerBatch,
    'AMS');

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return { data: formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number): Promise<Array<any>> {
    const apiResult = await api.getListItems(JobNames.AMSVoyage, 'AmsVoyageListItem',
      AmsVoyageListItem.calculateSearchParameters(search,AmsVoyageListItem.MapSearchFields),
      pageNum,
      limit,
      pageSize,
      pagePerBatch,
      'AMS'
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return formatData(apiResult.entities);
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(): ListRowRenderer[] {
    return AmsVoyageListItem.getExportCollection().map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if(x.dataIndex === "status") {
        colRenderer.Cell = () => <span></span>
        colRenderer.Header = () => <span></span>;
      }
      else if(x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      // else if(x.type === XCol.XCellType.StrBool) colRenderer.Cell = BlockRenderer;
      // else if(x.type === XCol.XCellType.Bool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'status', changedValue: (value: any)=> { return value['status'] === 'PC' ? 'Period Close' : ''}});
    colRenderer.push({accessor: 'block', changedValue: (value: any)=> { return nullableCheckBoxValue(value['block'])}});
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'id',
      orderByAscending: false,
    };
  }

  getTableSettings(): TableSettings {
    const tsettings = amsVoyageList;
    const cols = AmsVoyageListItem.getExportCollection();
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });

    return tsettings;
  }

  renderCommands() {
    return (
      <ViListCommands />
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ViListToolbar />
    );
  }

  renderExtras() {
    return <ViListViewExtras />
  }

  getViewUrlFor() {
    return '';
  }

  hasViewPopup(): boolean {
    return true;
  }

  getListViewTitle() {
    return `AMS Voyage List`;
  };

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  hasMemo(): boolean {
    return false;
  }
};

export default VoyageListView;
